/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RecentActivity } from '../models/RecentActivity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RecentActivitiesService {
    /**
     * Get all recent activities
     * @returns RecentActivity successful
     * @throws ApiError
     */
    public static getAllRecentActivities(): CancelablePromise<Array<RecentActivity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/recent_activities.json',
        });
    }
    /**
     * Create or update recent activities
     * @param requestBody
     * @returns RecentActivity successful
     * @throws ApiError
     */
    public static saveRecentActivities(
        requestBody?: {
            recentActivities: Array<{
                key: string;
                activityType: string;
                activityTime: string;
            }>;
        },
    ): CancelablePromise<Array<RecentActivity>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/recent_activities.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
